import React from 'react'
import T from 'prop-types'

import { Input, Text, Icon, Chip } from '@wework/dieter-ui'
import PopupAwayClick from 'components/PopupAwayClick'

class InputFilterControl extends React.PureComponent {
  state = {
    value: '',
    open: false,
  }

  onSubmit = (e, onSubmit) => {
    e.preventDefault()
    onSubmit(this.state.value)
  }

  onChange = value => {
    this.setState({ value })
  }

  handleClick = () => {
    this.setState(state => {
      return {
        open: !state.open,
      }
    })
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  handleOnClickOutside = e => {
    if (e.target.tagName === 'CANVAS') {
      this.setState({ open: false })
    }
  }

  render() {
    const {
      label,
      submittedValue,
      placeholder,
      descriptions,
      onSubmit,
      onDelete,
      setChipLabel,
      disabled,
    } = this.props

    const { value } = this.state

    return (
      <PopupAwayClick
        // label={label}
        // chipLabel={submittedValue ? setChipLabel(submittedValue) : ''}
        // onDelete={() => {
        //   onDelete()
        //   this.setState({ open: false, value: '' })
        // }}
        // handleClick={this.handleClick}
        // handleClose={this.handleClose}
        // handleOnClickOutside={this.handleOnClickOutside}
        // open={this.state.open}
        // disabled={disabled}
        setter={e => this.setState({ open: e })}
        open={this.state.open}
        position="bottom left"
        closeOnTriggerMouseLeave={true}
        disabled={disabled}
        trigger={
          <Chip
            onClick={this.handleClick}
            primary={submittedValue}
            active={submittedValue}
          >
            {submittedValue ? setChipLabel(submittedValue) : label}
            <div
              style={{ display: 'inline', marginLeft: 8 }}
              onClick={() => {
                onDelete()
              }}
            >
              <Icon fitted name={this.state.open ? 'x' : 'caret down'} />
            </div>
          </Chip>
        }
        on="click"
        style={{ padding: 0, maxWidth: 'none' }}
        content={
          <div
            style={{ width: '260px', whiteSpace: 'pre-wrap', padding: '16px' }}
          >
            <form
              onSubmit={e => {
                this.onSubmit(e, onSubmit)
                this.setState({ open: false, value: '' })
              }}
            >
              <Input
                value={value === undefined ? '' : value}
                onChange={e => {
                  this.onChange(e.target.value)
                }}
                style={{ paddingBottom: '16px' }}
                placeholder={placeholder}
                fluid
                focus
              />
              <br />
              <Text>{descriptions}</Text>
            </form>
          </div>
        }
      />
    )
  }
}

InputFilterControl.propTypes = {
  label: T.string.isRequired,
}

InputFilterControl.defaultProps = {}

export default InputFilterControl
